// ============================================================
// Navbar — แถบด้านบน + เมนูด้านข้าง (ใช้ทุกหน้าจอหลังล็อกอิน)
// ------------------------------------------------------------
// นอกจากแสดงเมนู ยังทำงานเบื้องหลัง 3 อย่างทุกครั้งที่เปลี่ยนหน้า
//   1. แทนชื่อค่าใช้จ่ายบนหน้าจอตามที่โครงการตั้งไว้ (replaceTextHTML)
//      + เฝ้าดู DOM ไว้ เผื่อมีข้อความใหม่ถูก render ทีหลัง
//   2. เตือนเมื่อเลยเวลาปิดรับชำระของวัน (เฉพาะหน้าที่เกี่ยวกับการรับเงิน)
//   3. sync ข้อมูลวันละครั้ง — คิดยอดค้าง/เบี้ยปรับใหม่ทั้งโครงการ
//
// ★ เมนูทั้งหมดถูกย้ายมาเป็นข้อมูลใน MENU ด้านล่าง
//   เพิ่ม/ลบ/ย้ายเมนู แก้ที่ MENU ที่เดียว ไม่ต้องไปยุ่งกับ JSX
// ============================================================

import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link } from "react-router";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Modal } from "react-bootstrap";

import LOGO from "../../assets/images/logo.png";
import { Logout, tokens, GET, POST, getStorage, alert_url, format_date, calculate_water, replaceTextHTML, loadReplaceTextHTML, getWaterSetting, ICON } from "../index.js";
import "../../assets/css/bootstrap.css";
import "../config/global.js";
import "react-pro-sidebar/dist/css/styles.css";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";

// หน้าที่ต้องเช็คเวลาปิดรับชำระ
const PAYMENT_PAGES = ["/record-water-usage", "/billing", "/record-receipt", "/record-other", "/record-bill"];

// ---------- โครงสร้างเมนู ----------
// item   : { path, label, icon?, role?, ownerOnly?, exact? }
//   role      = ชื่อเมนูใน role_detail ที่ต้องมีสิทธิ์ view ถึงจะเห็น
//   ownerOnly = เห็นเฉพาะ user_type === "owner"
//   exact     = ไฮไลต์เมนูเมื่อ path ตรงเป๊ะเท่านั้น (กันชนกับ /receipt-other)
// submenu: { title, icon, children: [...], openWhen: [path ที่ทำให้เมนูกางอยู่] }
const MENU = [
  { path: "/customer", label: "ข้อมูลลูกค้าโครงการ 🟢", icon: ICON.user, role: "customer" },
  { path: "/temp-record-water-usage", label: "ข้อมูลค่าใช้จ่ายโครงการ 🟢", icon: ICON.map_marker, role: "record-water-usage" },
  {
    title: "ข้อมูลจัดเก็บค่าใช้จ่าย",
    icon: ICON.building,
    openWhen: ["billing", "record-receipt", "receipt-adjustment", "record-other", "record-bill", "bill-water", "remittance", "usage-history", "capital-payment-info", "water-payment-info", "cut-of"],
    children: [
      { path: "/billing", label: "ออกใบแจ้งหนี้ 🟢", role: "billing" },
      { path: "/record-receipt", label: "รับชำระค่าใช้จ่าย 🟢", role: "record-receipt" },
      { path: "/receipt-adjustment", label: "ปรับปรุงใบเสร็จรับเงิน 🟢", role: "receipt-adjustment" },
      { path: "/record-other", label: "บันทึกรายรับอื่นๆ 🟢", role: "record-other" },
      { path: "/record-bill", label: "ออกใบแจ้งหนี้อื่นๆ 🟢", role: "record-other" },
      { path: "/bill-water", label: "การจัดเก็บค่าใช้จ่าย 🟢", role: "bill-water" },
      { path: "/remittance", label: "การนำส่งเงินค่าใช้จ่าย 🟢", role: "remittance" },
      { path: "/usage-history", label: "ประวัติค่าใช้จ่าย 🟢", role: "usage-history" },
      { path: "/capital-payment-info", label: "ข้อมูลการรับชำระเงินทุน 🟢", role: "capital-payment-info" },
      { path: "/water-payment-info", label: "ข้อมูลจัดเก็บค่าใช้จ่าย 🟢", role: "water-payment-info" },
      { path: "/cut-of", label: "รายการตัดหนี้ 🟢", role: "cut-of" },
    ],
    // หัวเมนูโผล่เมื่อมีสิทธิ์ตัวใดตัวหนึ่ง หรือเป็นเจ้าของระบบ
    showWhen: ["billing", "record-receipt", "receipt-adjustment", "record-other", "bill-water", "remittance", "usage-history", "capital-payment-info"],
    showForOwner: true,
  },
  { path: "/all-report", label: "รายงานสรุปผล", icon: ICON.folder, role: "all-report" },
  { path: "/import", label: "นำเข้าไฟล์ข้อมูล 🟢", icon: ICON.folder, role: "import", ownerAlso: true },
  {
    title: "ข้อมูลผู้ใช้ 🟢",
    icon: ICON.user,
    openWhen: ["employee", "role"],
    children: [
      { path: "/employee", label: "รายชื่อผู้ใช้ทั้งหมด 🟢", role: "employee" },
      { path: "/role", label: "บทบาทผู้ใช้ 🟢", role: "role" },
    ],
    showWhen: ["employee", "role"],
  },
  {
    title: "ตั้งค่า 🟢",
    icon: ICON.gear,
    openWhen: ["profile-code", "invoice-item-code", "profile", "manage-water", "receipt", "receipt-other", "invoice-by-room", "letter", "invoice-other"],
    children: [
      { path: "/profile-code", label: "รายการรับชำระ 🟢", role: "pay-list" },
      { path: "/invoice-item-code", label: "รายการออกใบแจ้งหนี้ 🟢", role: "pay-list" },
      { path: "/manage-water", label: "จัดการอัตราค่าน้ำ 🟢", role: "manage-water" },
      { path: "/profile", label: "จัดการโปรไฟล์ 🟢", ownerOnly: true },
      { path: "/receipt", label: "(เอกสาร) ใบเสร็จรับเงิน 🟢", role: "letter", exact: true },
      { path: "/receipt-other", label: "(เอกสาร) รายรับอื่น ๆ 🟢", role: "letter" },
      { path: "/invoice-by-room", label: "(เอกสาร) ใบแจ้งหนี้ตามห้อง 🟢", role: "letter" },
      { path: "/letter", label: "(เอกสาร) จดหมายแจ้งเตือน 🟢", role: "letter" },
      { path: "/invoice-other", label: "(เอกสาร) ใบแจ้งหนี้อื่น ๆ 🟢", role: "letter" },
    ],
    showWhen: ["pay-list", "manage-water", "letter"],
    showForOwner: true,
  },
  { path: "/logfile", label: "ล็อกไฟล์ 🟢", icon: ICON.clock, ownerOnly: true },
  { path: "/bookbank", label: "บันทึก Bookbank", icon: ICON.tag, role: "bookbank" },
  { path: "/statement", label: "บันทึก statement (บัญชี)", icon: ICON.tag, role: "statement" },
  { path: "/gl/reconcile", label: "กระทบยอด GL", icon: ICON.tag, role: "gl-reconcile" },
];

export default function NavbarComponent({ sidebar: initSidebar, page1, page2, page3 }) {
  const [sidebar, setSidebar] = useState(false);
  const [modalLogout, setModalLogout] = useState(false);
  const [modalSync, setModalSync] = useState(false);
  const [syncTime, setSyncTime] = useState(0);

  const path = window.location.pathname;
  const userType = getStorage("user_type");
  const projectId = getStorage("project_id");

  // สิทธิ์ "ดู" ของแต่ละเมนู แปลงเป็น map ครั้งเดียว
  const roleMap = useMemo(() => (getStorage("role_detail") || []).reduce((m, r) => ({ ...m, [r.name]: r.role[0] === 1 }), {}), []);
  const hasR = (name) => !!roleMap[name];

  // เมนูนี้ตรงกับหน้าที่เปิดอยู่ไหม
  const isActive = useCallback(
    (key) => {
      const target = key.startsWith("/") ? key : `/${key}`;
      return path === target || path.startsWith(`${target}/`);
    },
    [path]
  );

  // ---------- งานเบื้องหลังตอนเปลี่ยนหน้า ----------
  useEffect(() => {
    (async () => {
      // แทนชื่อค่าใช้จ่ายตามที่โครงการตั้งไว้
      await loadReplaceTextHTML();
      await replaceTextHTML();

      // เตือนเมื่อเลยเวลาปิดรับชำระของวัน (เฉพาะหน้าที่รับเงิน และต้องมีรอบบิลเปิดอยู่)
      if (PAYMENT_PAGES.some(isActive)) {
        const [resBill, setting] = await Promise.all([GET(tokens, `v1/TH/bill-water-group/filter-search/${projectId}`, { data_search: "" }), getWaterSetting()]);
        const closeTime = setting?.payment_close_time;
        if (closeTime && resBill?.data?.data?.length) {
          const [hour, minute] = closeTime.split(":");
          if (new Date().setHours(hour, minute, 0, 0) < Date.now()) {
            alert_url("warning", "แจ้งเตือน", "สิ้นสุดเวลาการชำระเงินวันนี้แล้ว", "/bill-water");
          }
        }
      }

      // sync ข้อมูลวันละครั้ง — คิดยอดค้าง/เบี้ยปรับใหม่ทั้งโครงการ
      const today = format_date(new Date());
      if (localStorage.getItem("sync_date") === today) return;

      setModalSync(true);
      // แถบความคืบหน้าแบบประมาณการ (วิ่งไปเรื่อย ๆ จนถึง 99% แล้วรอผลจริง)
      const progress = setInterval(() => setSyncTime((p) => Math.min(p + 0.2, 99)), 50);

      const synced = await calculate_water();
      clearInterval(progress);

      if (synced) {
        await calculate_transaction_payment();
        // บันทึกว่า sync วันนี้แล้ว จะได้ไม่ทำซ้ำทุกครั้งที่เปลี่ยนหน้า
        localStorage.setItem("sync_date", today);
        setSyncTime(100);
        setTimeout(() => setModalSync(false), 2000);
        return;
      }

      // sync ไม่สำเร็จ — ปิดหน้าต่างแล้วให้ใช้งานต่อได้ตามปกติ
      //
      // NOTE เดิมตรงนี้ทำ localStorage.clear() แล้วเด้งไป "/" = เตะผู้ใช้ออกจากระบบ
      //      ซึ่งทำให้เกิดอาการ "คนอื่นล็อกอิน แล้วเราหลุด":
      //      calculate_water() คำนวณยอดใหม่ทั้งโครงการ ถ้า 2 คนรันชนกัน
      //      ฝั่งที่ช้ากว่าจะได้ error แล้วถูกเตะออกทั้งที่ session ยังใช้ได้อยู่
      //      การ sync ล้มเหลวไม่ใช่เรื่องของสิทธิ์ จึงไม่ควรล้าง session
      //      (ไม่บันทึก sync_date ไว้ ระบบจะลองใหม่เองตอนเปลี่ยนหน้าครั้งต่อไป)
      setModalSync(false);
      setSyncTime(0);
    })();
  }, [path, projectId, isActive]);

  // ซ่อมรายการรับชำระที่ผูกกับบิลไม่ครบ (ทำพร้อมกับ sync รายวัน)
  const calculate_transaction_payment = async () => {
    try {
      await POST(tokens, "v1/TH/record-receipt/history/fix-transaction-payments/" + getStorage("project_id"), null);
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  // เฝ้าดูข้อความที่ render เพิ่มทีหลัง แล้วแทนชื่อค่าใช้จ่ายให้ด้วย
  useEffect(() => {
    let timeoutId;
    const observer = new MutationObserver(() => {
      clearTimeout(timeoutId);
      // หน่วง 100ms กันเรียกรัว ๆ จนหน้าจอหน่วง
      timeoutId = setTimeout(async () => {
        observer.disconnect(); // ปิดการดักจับชั่วคราวขณะแก้ข้อความ กัน loop ไม่รู้จบ
        await replaceTextHTML();
        observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      }, 100);
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, []);

  // ---------- ตัวช่วยวาดเมนู ----------

  // เมนูนี้ผู้ใช้คนนี้เห็นไหม
  const canSee = (item) => {
    if (item.ownerOnly) return userType === "owner";
    if (item.ownerAlso && userType === "owner") return true;
    return item.role ? hasR(item.role) : true;
  };

  const renderItem = (item, key) =>
    canSee(item) ? (
      <MenuItem key={key} icon={item.icon && <label className="icon">{item.icon}</label>} active={item.exact ? path === item.path : isActive(item.path)}>
        <Link to={item.path}>{item.label}</Link>
      </MenuItem>
    ) : null;

  const renderSubMenu = (group, key) => {
    // หัวเมนูโผล่เมื่อมีสิทธิ์ลูกเมนูตัวใดตัวหนึ่ง (หรือเป็นเจ้าของระบบสำหรับบางกลุ่ม)
    const visible = group.showWhen.some(hasR) || (group.showForOwner && userType === "owner");
    if (!visible) return null;
    return (
      <SubMenu key={key} icon={<label className="icon">{group.icon}</label>} title={group.title} defaultOpen={group.openWhen.some(isActive)}>
        {group.children.map((child, i) => renderItem(child, `${key}-${i}`))}
      </SubMenu>
    );
  };

  return (
    <div>
      {/* แถบด้านบน: โลโก้ + breadcrumb + ชื่อผู้ใช้/โครงการ + ปุ่มออกจากระบบ */}
      <div className="w-100 mx-0 px-0 position-fixed d-flex justify-content-between bg-white shadow px-4 py-2" style={{ height: 60, zIndex: 1010 }}>
        <div className="align-items-center d-flex row mx-0">
          {/* ปุ่มเปิดเมนูบนจอเล็ก */}
          {initSidebar !== "false" && !isActive("pos") && (
            <label className="d-block d-lg-none mr-3 mt-2" onClick={() => setSidebar(!sidebar)}>
              <span className="icon-brand text-dark">{ICON.menu}</span>
            </label>
          )}
          <div className="position-relative wpx-200">
            <img className="hpx-32 mb-2 mx-auto" alt="logo" src={LOGO} />
            <br />
            <small className="position-absolute" style={{ left: 100, bottom: 4 }}>
              {process.env.REACT_APP_VERSION}
            </small>
            <small className="position-absolute text-8" style={{ right: 0, bottom: -6 }}>
              ©copy right by c.d.s. service .co.,ltd and OMS service
            </small>
          </div>
          <div className="d-none d-md-flex">
            <div className="border-right mx-3" style={{ height: 24 }}></div>
            <small className="text-secondary">{page1}</small>
            {page2 && <small className={page3 ? "text-secondary ml-2" : "text-primary ml-2"}> &gt; {page2}</small>}
            {page3 && <small className="text-primary ml-2"> &gt; {page3}</small>}
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-center">
          <div>
            <b className="ml-auto mr-3 d-none d-sm-flex">{getStorage("full_name")}</b>
            {/* กดชื่อโครงการ = กลับไปเลือกโครงการใหม่ (ล้าง cache ชื่อค่าใช้จ่ายของโครงการเดิมด้วย) */}
            <small
              className="mr-3 align-items-center d-none d-sm-flex pointer"
              onClick={() => {
                localStorage.removeItem("replace_text");
                window.location.href = "/choose-project";
              }}
            >
              {getStorage("project_name")}
            </small>
          </div>
          <span className="pointer btn-white icon text-danger text-14" onClick={() => setModalLogout(true)}>
            {ICON.door}
          </span>
        </div>
      </div>

      {/* เมนูด้านข้าง */}
      <ProSidebar className="full-screen" breakPoint="lg" toggled={sidebar}>
        <Menu>{MENU.map((entry, i) => (entry.children ? renderSubMenu(entry, i) : renderItem(entry, i)))}</Menu>
      </ProSidebar>

      {/* popup ยืนยันออกจากระบบ */}
      <Modal show={modalLogout} onHide={() => setModalLogout(false)}>
        <Modal.Header>
          <Modal.Title>
            <b>ออกจากระบบ</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 mb-3">
            <label>ยืนยันการออกจากระบบหรือไม่</label>
          </div>
          <div className="w-100 d-flex">
            <div className="w-50 p-1">
              <button className="btn btn-outline-primary w-100" onClick={() => setModalLogout(false)}>
                ยกเลิก
              </button>
            </div>
            <div className="w-50 p-1">
              <button className="btn btn-primary w-100" onClick={Logout}>
                ออกจากระบบ
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* popup แสดงความคืบหน้าตอน sync ข้อมูลรายวัน */}
      <Modal show={modalSync} dialogClassName="modal-fullscreen">
        <Modal.Body>
          <div className="w-100 min-vh-100 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <h2 className="text-bold mb-3">กำลัง sync ข้อมูลระบบ</h2>
              <div className="hpx-24 wpx-320 border bg-light position-relative">
                <div style={{ width: (syncTime / 100) * 320 }} className="bg-primary hpx-24"></div>
                <label>{syncTime.toFixed(2)} %</label>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
